import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import Landing from "@/pages/Landing";
import Explore from "@/pages/Explore";
import Output from "@/pages/Output";
import Wallet from "@/pages/Wallet";
import SandboxRequest from "@/pages/SandboxRequest";
import About from "@/pages/About";
import JourneyGovernedAgenticProcurement from "@/pages/JourneyGovernedAgenticProcurement";
import Journeys from "@/pages/Journeys";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <SiteHeader />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/explore/output" element={<Output />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/sandbox-request" element={<SandboxRequest />} />
            <Route path="/about" element={<About />} />
            <Route path="/journeys" element={<Journeys />} />
            <Route
              path="/journeys/governed-agentic-procurement"
              element={<JourneyGovernedAgenticProcurement />}
            />
          </Routes>
        </main>
        <SiteFooter />
        <Toaster richColors position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
